<template>
  <Dialog scrollable :common-dialog="visitDialog" :dialog-width="dialogWidth">
    <template v-slot:title>
      <v-layout v-if="visitDialog">
        <v-flex md6 class="d-flex">
          <h1
            class="form-title custom-nowrap-ellipsis text-capitalize mb-0 cursor-pointer"
            v-on:click="routeDetail"
          >
            Visit #{{ visitDetail.barcode }}
          </h1>
          <Priority
            v-if="detail.priority"
            :priority="detail.priority"
          ></Priority>
           <v-chip
            class="mx-2 mb-1 custom-status font-weight-600 custom-grey-border text-uppercase justify-center font-10"
            :color="getStatusColor(visitDetail.status)"
            label
            :text-color="
              visitDetail.status == 2 ? 'black' : 'white'
            "
          >
            {{ visitDetail.status_text }}
          </v-chip>
          <template v-if="visitDetail.status && visitDetail.status != 4 && false">
            <CustomStatus
              :status="visitDetail.status"
              endpoint="visit/status"
            ></CustomStatus>
          </template>
        </v-flex>

        <v-flex md6 class="d-flex justify-end">
          <div v-if="!pageLoading" class="d-flex justify-end">
            <v-btn
              v-if="visitDetail.status == 4"
              class="mx-2 custom-grey-border custom-bold-button text-white"
              color="light-green darken-1"
            >
              <v-icon left>mdi-check-decagram</v-icon> Completed
            </v-btn>
            <!--<v-btn
              v-if="visitDetail.status != 5 && visitDetail.status != 4"
              v-on:click="startTimerWithLater()"
              :disabled="timerFormLoading"
              :loading="timerFormLoading"
              color="cyan white--text"
              class="mx-2 custom-grey-border custom-bold-button"
            >
              Mark as Complete
            </v-btn>-->
            <v-menu
              v-if="visitDetail.status != 2 && visitDetail.status != 5 && false"
              content-class="custom-menu-list"
              offset-y
              left
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="mx-2 custom-grey-border custom-bold-button"
                  color="cyan white--text"
                  v-bind="attrs"
                  v-on="on"
                >
                  More...
                </v-btn>
              </template>

              <v-list>
                <v-list-item
                  v-if="visitDetail.status == 4"
                  v-on:click="routeToInvoice()"
                >
                  <v-list-item-title class="font-weight-600 font-size-16"
                    >Generate Invoice</v-list-item-title
                  >
                </v-list-item>
                <v-list-item
                  v-if="visitDetail.status == 4"
                  v-on:click="downloadPDF()"
                >
                  <v-list-item-title class="font-weight-600 font-size-16"
                    >Download PDF</v-list-item-title
                  >
                </v-list-item>
                <v-list-item
                  v-if="visitDetail.status == 1"
                  v-on:click="appointmentUpdateDialog = true"
                >
                  <v-list-item-title class="font-weight-600 font-size-16"
                    >Re-Schedule</v-list-item-title
                  >
                </v-list-item>
                <v-list-item
                  v-if="detail.type == 2"
                  v-on:click="downloadSchedule()"
                >
                  <v-list-item-title class="font-weight-600 font-size-16"
                    >Download Schedule</v-list-item-title
                  >
                </v-list-item>
                <v-list-item
                  v-if="visitDetail.status == 1"
                  v-on:click="cancelVisitDialog = true"
                >
                  <v-list-item-title class="font-weight-600 font-size-16"
                    >Cancel Visit</v-list-item-title
                  >
                </v-list-item>
                <v-list-item
                  v-if="visitDetail.status == 1 && type == 'simple'"
                  v-on:click="getAvailableEngineers()"
                >
                  <v-list-item-title class="font-weight-600 font-size-16"
                    >Get Available Technicians</v-list-item-title
                  >
                </v-list-item>
              </v-list>
            </v-menu>
            <template v-if="!pageLoading">
              <template v-if="visitDetail.status == 1">
                <template v-if="engineerList.length">
                  <v-menu bottom left offset-y :close-on-content-click="false">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="mx-2 custom-bold-button white--text"
                        color="cyan"
                        :disabled="apptEngLoading"
                        :loading="apptEngLoading"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon class="mr-2">mdi-account-group</v-icon>Assign
                      </v-btn>
                    </template>
                    <v-list class="light-gray-background pb-0" min-width="340">
                      <v-list-item-title
                        class="text-uppercase font-weight-700 color-custom-blue font-size-16 p-2 pt-0"
                      >
                        Select Team
                      </v-list-item-title>
                      <perfect-scrollbar
                        :options="{ suppressScrollX: true }"
                        class="scroll custom-box-top-inner-shadow"
                        style="max-height: 50vh; position: relative"
                      >
                        <v-list-item
                          class="white-background"
                          v-for="(team, index) in engineerList"
                          :key="index"
                        >
                          <v-checkbox
                            v-model="assignedTeam"
                            :label="team.display_name"
                            :value="team.id"
                            hide-details
                            color="cyan"
                            class="mr-4 mt-0"
                            :disabled="apptEngLoading"
                            multiple
                          >
                            <template v-slot:label>
                              <v-list-item>
                                <v-list-item-avatar>
                                  <v-img
                                    :lazy-src="$defaultProfileImage"
                                    :src="$assetAPIURL(team.profile_logo)"
                                  ></v-img>
                                </v-list-item-avatar>
                                <v-list-item-content>
                                  <v-tooltip
                                    top
                                    content-class="custom-top-tooltip"
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-list-item-title
                                        v-bind="attrs"
                                        v-on="on"
                                        class="font-size-16 font-weight-500"
                                        v-html="team.display_name"
                                      ></v-list-item-title>
                                    </template>
                                    <span class="text-capitalize">
                                      <template v-if="team.skills">{{
                                        team.skills.join(", ")
                                      }}</template>
                                      <template v-else-if="team.designation">{{
                                        team.designation.value
                                      }}</template>
                                      <template v-else
                                        ><em>No Skills</em></template
                                      >
                                    </span>
                                  </v-tooltip>
                                  <v-list-item-subtitle
                                    v-if="
                                      lodash.isEmpty(team.designation) == false
                                    "
                                    >{{
                                      team.designation.value
                                    }}</v-list-item-subtitle
                                  >
                                </v-list-item-content>
                              </v-list-item>
                            </template>
                          </v-checkbox>
                        </v-list-item>
                      </perfect-scrollbar>
                      <v-btn
                        :disabled="apptEngLoading"
                        :loading="apptEngLoading"
                        v-on:click="updateEngineer()"
                        color="cyan white--text"
                        class="w-100 text-uppercase font-weight-700 font-size-16"
                        >Save</v-btn
                      >
                    </v-list>
                  </v-menu>
                </template>
              </template>
            </template>
            <v-btn
              depressed
              class="ml-2 custom-grey-border custom-bold-button"
              v-on:click="$emit('close', true)"
            >
              Close
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
    </template>

    <template v-slot:body>
      <v-container>
        <v-row>
          <v-col cols="5" class="pb-0">
            <h3 v-if="customer.customer">
              <router-link
                :to="
                  getDefaultRoute('customer.detail', {
                    params: {
                      id: customer.customer,
                    },
                  })
                "
                >{{ customer.display_name }}
              </router-link>
            </h3>
            <span
              class="color-custom-blue font-weight-700 font-size-20 text-truncate"
              style=""
              >{{
                visitDetail && visitDetail.ticket && visitDetail.ticket.title
              }}
            </span>
            <v-layout class="my-4">
              <v-flex md6 class="mr-2 custom-border-right">
                <table width="100%">
                  <tr>
                    <td class="font-weight-600">Site Location</td>
                  </tr>
                  <tr>
                    <td class="py-0 font-size-18 font-weight-500">
                      <a
                        target="_blank"
                        :href="`https://maps.google.com/?q=${property.property_address}`"
                        >{{ property.property_address }}</a
                      >
                    </td>
                  </tr>
                  <tr>
                    <td class="font-weight-600">Contact details</td>
                  </tr>
                  <tr v-if="property_contact_person.display_name">
                    <td class="py-0 font-size-18 font-weight-500">
                      {{ property_contact_person.display_name }}
                    </td>
                  </tr>
                  <tr v-if="property_contact_person.primary_phone">
                    <td class="py-0 font-size-18 font-weight-500">
                      {{ property_contact_person.primary_phone }}
                    </td>
                  </tr>
                  <tr v-if="property_contact_person.primary_email">
                    <td class="py-0 font-size-18 font-weight-500">
                      {{ property_contact_person.primary_email }}
                    </td>
                  </tr>
                </table>
              </v-flex>
              <v-flex md6 class="ml-2">
                <table width="100%">
                  <tr>
                    <td class="font-weight-600">Billing Address</td>
                  </tr>
                  <tr>
                    <td class="py-0 font-size-18 font-weight-500">
                      <a
                        target="_blank"
                        :href="`https://maps.google.com/?q=${billing.property_address}`"
                        >{{ billing.property_address }}</a
                      >
                    </td>
                  </tr>
                  <tr>
                    <td class="font-weight-600">Contact details</td>
                  </tr>
                  <tr v-if="billing_contact_person.display_name">
                    <td class="py-0 font-size-18 font-weight-500">
                      {{ billing_contact_person.display_name }}
                    </td>
                  </tr>
                  <tr v-if="billing_contact_person.primary_phone">
                    <td class="py-0 font-size-18 font-weight-500">
                      {{ billing_contact_person.primary_phone }}
                    </td>
                  </tr>
                  <tr v-if="billing_contact_person.primary_email">
                    <td class="py-0 font-size-18 font-weight-500">
                      {{ billing_contact_person.primary_email }}
                    </td>
                  </tr>
                </table>
              </v-flex>
            </v-layout>
          </v-col>
          <v-col md="7" class="pb-0 gray-background pl-4">
            <v-container fluid>
              <v-row dense>
                <v-col md="12">
                  <v-skeleton-loader
                    class="custom-skeleton height-30px mr-2 my-auto custom-skeleton-full-width"
                    width="100"
                    type="text"
                    v-if="pageLoading"
                  >
                  </v-skeleton-loader>
                  <v-chip
                    v-else
                    class="my-2 font-weight-600"
                    color="chip-custom-blue"
                    label
                    outlined
                  >
                    {{ getScheduleType }}
                  </v-chip>
                  <template v-if="pageLoading">
                    <v-skeleton-loader
                      v-for="(d, i) in 2"
                      :key="i"
                      class="custom-skeleton height-40px custom-skeleton-full-width mr-5"
                      :class="{ 'mt-3': i <= 0, 'my-1': i > 0 }"
                      type="text"
                    >
                    </v-skeleton-loader>
                  </template>
                  <template v-else>
                    <table class="width-100">
                      <tr>
                        <td class="font-size-18 py-1" width="200">
                          Visit Number
                        </td>
                        <!-- <td class="font-weight-600 font-size-18 py-1">
                          {{ visitDetail.barcode }}
                        </td> -->
                        <td class="font-weight-600 font-size-18 py-1">
                          <template>
                            <router-link
                              :to="{
                                name: 'admin.visit.detail',
                                params: {
                                  id: visitDetail.id,
                                },
                              }"
                              target="_blank"
                            >
                              <Barcode
                                dense
                                small
                                :barcode="visitDetail.barcode"
                              ></Barcode>
                            </router-link>
                          </template>
                        </td>
                      </tr>
                      <tr>
                        <td class="font-size-18 py-1" width="200">
                          Appointment
                        </td>
                        <td class="font-weight-600 font-size-18 py-1">
                          <span style="color: #24326d !important">
                            {{ getAppointmentText }}</span
                          >
                          <!--  <v-tooltip top content-class="custom-top-tooltip">
                            <template v-slot:activator="{ on, attrs }">
                              <a
                                v-bind="attrs"
                                v-on="on"
                                href="javascript:void(0)"
                                v-on:click="downloadVisit"
                                class="text-uppercase max-content-width"
                                >{{ getAppointmentText }}</a
                              >
                            </template>
                            <span>Click here to download Appointment</span>
                          </v-tooltip>
                          <v-tooltip
                            top
                            content-class="custom-top-tooltip"
                            v-if="
                              visitDetail.status != 4 &&
                              visitDetail.status != 2 &&
                              visitDetail.status != 5
                            "
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                :disabled="isTimmerRunning"
                                icon
                                text
                                class="mx-2"
                                v-on:click="appointmentUpdateDialog = true"
                                ><v-icon v-bind="attrs" v-on="on" color="cyan"
                                  >mdi-clock-fast</v-icon
                                ></v-btn
                              >
                            </template>
                            <span>Click here to reschedule Appointment</span>
                          </v-tooltip> -->
                        </td>
                      </tr>
                      <tr>
                        <td class="font-size-18 py-1" width="200">
                          Technicians
                        </td>
                        <td class="font-weight-600 font-size-18 py-1">
                          <span v-if="visitDetail.assigned_engineers">
                            <v-chip
                              style="height: 26px"
                              v-for="(
                                row, index
                              ) in visitDetail.assigned_engineers"
                              :key="index"
                              class="mx-2"
                              color="cyan white--text"
                              label
                            >
                              <v-icon small left> mdi-account-circle </v-icon>
                              {{ row }}
                            </v-chip>
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td class="font-size-18 py-1 d-flex" width="200">
                          <b> Service Report PDF</b>
                        </td>
                        <td class="font-weight-600 font-size-18 py-1">
                          <span
                            v-if="
                              visitDetail.service_form &&
                              visitDetail.service_form.length > 0 /*  &&
                              visitDetail.status == 4 */
                            "
                          >
                            <v-tooltip
                              top
                              content-class="custom-top-tooltip"
                              v-for="(row, index) in visitDetail.service_form"
                              :key="index"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  v-if="row?.view_pdf_url"
                                   :color="row.is_filled == 0 ? '#d3be09'  : row.need_cost == 1  ? 'black' : 'red'"
                                  v-bind="attrs"
                                  v-on="on"
                                  class="mx-2 custom-bold-button white--text mb-1"
                                 
                                  v-on:click.stop.prevent="
                                    downloadFile(row.view_pdf_url)
                                  "
                                >
                                  <v-icon left>mdi-file-pdf</v-icon>
                                  {{ getBarcode(row) }}
                                </v-btn>
                              </template>
                              <span>{{ getText(row) }}</span>
                            </v-tooltip>
                          </span>
                          <em class="text-muted" v-else> No Service Report</em>
                        </td>
                      </tr>
                      <tr v-if="getVisitScheduleType()">
                        <td class="font-size-18 py-1 d-flex" width="200">
                          Schedule
                        </td>
                        <td class="font-weight-600 font-size-18 py-1">
                          <read-more
                            class="custom-read-more font-weight-600 font-size-16 pb-1 pr-2 custom-gray-color"
                            more-str="read more"
                            :text="getVisitScheduleType()"
                            link="#"
                            less-str="read less"
                            :max-chars="60"
                          >
                          </read-more>
                        </td>
                      </tr>
                    </table>
                  </template>
                </v-col>
              </v-row>
            </v-container>
          </v-col>
          <v-col cols="4" class="pb-0" v-if="false">
            <v-container fluid>
              <v-row dense>
                <v-col md="12"></v-col>
                <v-col md="12"></v-col>
                <v-col md="12">
                  <v-skeleton-loader
                    class="custom-skeleton height-30px mr-2 my-auto custom-skeleton-full-width"
                    width="100"
                    type="text"
                    v-if="pageLoading"
                  >
                  </v-skeleton-loader>
                  <v-chip
                    v-else
                    class="my-2 font-weight-600"
                    color="chip-custom-blue"
                    label
                    outlined
                  >
                    {{ getScheduleType }}
                  </v-chip>
                  <template v-if="pageLoading">
                    <v-skeleton-loader
                      v-for="(d, i) in 2"
                      :key="i"
                      class="custom-skeleton height-40px custom-skeleton-full-width mr-5"
                      :class="{ 'mt-3': i <= 0, 'my-1': i > 0 }"
                      type="text"
                    >
                    </v-skeleton-loader>
                  </template>
                  <template v-else>
                    <table class="width-100">
                      <tr>
                        <td class="font-size-18 py-1" width="200">
                          Technicians
                        </td>
                        <td class="font-weight-600 font-size-18 py-1">
                          <span v-if="visitDetail.assigned_engineers">
                            <v-chip
                              style="height: 26px"
                              v-for="(
                                row, index
                              ) in visitDetail.assigned_engineers"
                              :key="index"
                              class="mx-2"
                              color="cyan white--text"
                              label
                            >
                              <v-icon small left> mdi-account-circle </v-icon>
                              {{ row }}
                            </v-chip>
                          </span>
                        </td>
                      </tr>
                    </table>
                  </template>
                </v-col>
              </v-row>
            </v-container>
          </v-col>
        </v-row>
      </v-container>

      <DeleteDialog :delete-dialog="cancelVisitDialog">
        <template v-slot:title>Cancel Confirmation</template>
        <template v-slot:text>
          <h3 class="font-size-16 font-weight-500 delete-text">
            Once you cancel
            <span class="font-weight-700">{{ visitDetail.barcode }}</span
            >, you won't be able to revert this later.<br />Are you sure you
            want to cancel
            <span class="font-weight-700">{{ visitDetail.barcode }}</span>
            ?
          </h3>
        </template>
        <template v-slot:action>
          <v-btn
            class="mx-2 custom-grey-border custom-bold-button"
            v-on:click="cancelVisitDialog = false"
            >No! Cancel</v-btn
          >
          <v-btn
            color="red lighten-1 white--text"
            v-on:click="cancelVisitConfirm()"
            class="mx-2 custom-grey-border custom-bold-button"
            >Yes! Cancel</v-btn
          >
        </template>
      </DeleteDialog>

      <Dialog :commonDialog="appointmentUpdateDialog">
        <template v-slot:title>Reschedule Appointment</template>
        <template v-slot:body>
          <v-container fluid class="py-0" style="min-height: 22vh">
            <v-row>
              <v-col md="4" class="py-1 font-weight-600"> Date </v-col>
              <v-col md="4" class="py-1 font-weight-600"> Start Time </v-col>
              <v-col md="4" class="py-1 font-weight-600"> End Time </v-col>
              <v-col md="4" class="py-1">
                <Datepicker
                  :defaultDate="updateStartDate"
                  solo
                  v-on:update:date-picker="updateAppointmentDate"
                ></Datepicker>
              </v-col>
              <v-col md="4" class="py-1">
                <v-autocomplete
                  dense
                  color="cyan"
                  filled
                  id="start-time"
                  :items="timeList"
                  v-model.trim="starTimereschdule"
                  placeholder="Start Time"
                  label="Start Time"
                  solo
                  flat
                  item-color="cyan"
                  hide-details
                />
              </v-col>
              <v-col md="4" class="py-1">
                <v-autocomplete
                  dense
                  color="cyan"
                  filled
                  id="end-time"
                  :items="timeList"
                  v-model.trim="endTimereschdule"
                  placeholder="End Time"
                  label="End Time"
                  solo
                  flat
                  item-color="cyan"
                  hide-details
                />
              </v-col>
              <v-col md="12" class="py-2" v-if="false">
                <em
                  >All engineers will be removed from visit#
                  {{ visitDetail.barcode }}</em
                >
              </v-col>
            </v-row>
          </v-container>
        </template>
        <template v-slot:action>
          <v-btn
            :disabled="apptFormLoading || pageLoading"
            :loading="apptFormLoading"
            class="mx-2 custom-grey-border custom-bold-button white--text"
            color="cyan"
            v-on:click="updateAppointment"
          >
            Save
          </v-btn>
          <v-btn
            :disabled="apptFormLoading || pageLoading"
            class="mx-2 custom-grey-border custom-bold-button"
            v-on:click="appointmentUpdateDialog = false"
          >
            Close
          </v-btn>
        </template>
      </Dialog>

      <!-- Create Closer -->
      <template v-if="getPermission('closer:create') && closerDialog">
        <CreateTimeCloser
          v-if="runningTimer.id"
          is-visit-detail
          :ticket-id="ticketId"
          :visit-id="visitId"
          :timesheet-id="runningTimer.id"
          :timesheet="runningTimer.id"
          :visit-detail="visitDetail"
          :closer-dialog="closerDialog"
          :detail="detail"
          v-on:create:ticket-closer="createdTimeCloser"
          v-on:close-dialog="closerDialog = false"
        ></CreateTimeCloser>
      </template>
    </template>
  </Dialog>
</template>

<script>
import moment from "moment-timezone";
import Barcode from "@/view/pages/partials/Barcode.vue";
import Dialog from "@/view/pages/partials/Dialog.vue";
import CommonMixin from "@/core/plugins/common-mixin";
import Priority from "@/view/pages/partials/Priority.vue";
import CustomStatus from "@/view/pages/partials/CustomStatus.vue";
import {
  PUT,
  QUERY,
  POST,
  PATCH,
  GET,
} from "@/core/services/store/request.module";
import JwtService from "@/core/services/jwt.service";
import { ErrorEventBus, InitializeError } from "@/core/lib/message.lib";
import { ServiceFormEventBus } from "@/core/lib/service.form.lib";
import { toNumber, isEmpty } from "lodash";
import { downloadEvent } from "@/core/lib/ics.lib";
import DeleteDialog from "@/view/pages/partials/Delete.vue";
import Datepicker from "@/view/pages/partials/Datepicker.vue";
//import Timepicker from "@/view/pages/partials/Timepicker.vue";
// import VueTimepicker from "vue2-timepicker/src/vue-timepicker.vue";
import CreateTimeCloser from "@/view/pages/job/partials/Create-Ticket-Closer.vue";

moment.tz.setDefault(process.env.VUE_APP_TIMEZONE);

export default {
  mixins: [CommonMixin],
  props: {
    visitDialog: {
      type: Boolean,
      default: false,
    },
    isCalendar: {
      type: Boolean,
      default: false,
    },
    visit: {
      type: Number,
      default: 0,
    },
    type: {
      type: String,
      default: null,
    },
  },
  watch: {
    visit: {
      deep: true,
      immediate: true,
      handler(param) {
        if (param) {
          this.loadContent();
        }
      },
    },
  },
  data() {
    return {
      yourFormat: "hh:mm A",
      starTimereschdule: null,
      endTimereschdule: null,
      ticketId: null,
      visitId: null,
      resumeTimerDialog: false,
      assignFormLoading: false,
      assignFormValid: true,
      appointmentUpdateDialog: false,
      timesheetRunningDialog: false,
      apptFormLoading: false,
      allowUpdate: false,
      timerLoading: true,
      timerDialog: false,
      closerDialog: false,
      startTimerDialog: false,
      completeDialog: false,
      updateServiceFormDialog: false,
      assignServiceFormDialog: false,
      allTimerDialog: false,
      timer_remarks: null,
      audioDataURL: null,
      timerFormValid: true,
      timerFormLoading: false,
      recordingStarted: false,
      recordingStopped: false,
      loadingEngineers: false,
      engineerDialog: false,
      apptEngLoading: false,
      runningTimer: new Object(),
      isTimmerRunning: false,
      pageLoading: false,
      detail: new Object(),
      visitDetail: {},
      customer: new Object(),
      contactPerson: new Object(),
      property: new Object(),
      property_contact_person: new Object(),
      billing_contact_person: new Object(),
      billing: new Object(),
      visitNotes: new Object(),
      particuleFieldLoading: false,
      updateDetailDialog: {
        title: false,
        instruction: false,
      },
      updateDetail: {
        title: null,
        instruction: null,
      },
      updateAppointmentFormData: {
        date: null,
        start_time: null,
        end_time: null,
      },
      serviceFormList: new Array(),
      engineerList: new Array(),
      visitEngineer: null,
      userRunningTimers: new Array(),
      timeInterval: null,
      durationInterval: null,
      timerServiceForm: new Array(),
      timeIntervalLimit: 10000,
      timerDuration: {
        hour: "00",
        minute: "00",
        second: "00",
      },
      closer: {
        pdf_url: null,
      },
      assignedTeam: [],
      dbLineItems: [],
      newLineItems: [],
      cancelVisitDialog: false,
      cancelVisitLoading: false,
      cancelVisitBarcode: null,
      lineItemLoading: false,
    };
  },
  methods: {
    getText(row){
    if (row.is_filled == 0) {
        return 'Service form in draft';
      } else if (row.need_cost == 1) {
        return 'Service form submitted but not signed by client';
      } else {
        return 'Service form submitted n signed by client';
      }
    },
    cancelVisitConfirm() {
      this.cancelVisitLoading = true;
      this.$store
        .dispatch(PUT, { url: `visit/${this.visitDetail.id}/mark-as-cancel` })
        .then(() => {
          this.loadContent();
          this.$emit("reload", true);
          this.cancelVisitDialog = false;
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.cancelVisitLoading = false;
        });
    },
    downloadFile(url, prepend_url) {
      if (!url) {
        return false;
      }
      if (prepend_url) {
        url = `https://bthrust-fsm.s3.ap-southeast-1.amazonaws.com/${url}`;
      }
      window.open(url, "_blank");
    },
    downloadSchedule() {
      const ticketId = this.visitDetail.ticket.id;
      const token = JwtService.getToken();
      const url = `${this.$apiURL}job/${ticketId}/download-schedule?token=${token}`;
      window.open(url, "_blank");
    },
    updateEngineer() {
      const visitId = this.visitDetail.id;
      const ticketId = this.visitDetail.ticket.id;
      const _this = this;
      if (!_this.assignedTeam.length) {
        ErrorEventBus.$emit(
          "update:error",
          InitializeError("Please select an engineer then try again.")
        );
        return false;
      }
      _this.apptEngLoading = true;
      _this.$store
        .dispatch(PUT, {
          url: "job/" + ticketId + "/visit/" + visitId + "/engineer",
          data: {
            engineer: _this.assignedTeam,
          },
        })
        .then(() => {
          _this.engineerList = [];
          _this.$nextTick(() => {
            _this.loadContent();
          });
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.apptEngLoading = false;
        });
    },
    getAvailableEngineers() {
      const _this = this;
      _this.loadingEngineers = true;
      _this.$store
        .dispatch(QUERY, {
          url: "job/available-engineers",
          data: {
            start_date: moment(_this.visitDetail.started_at).format(
              "YYYY-MM-DD"
            ),
            start_time: moment(_this.visitDetail.started_at).format("HH:mm"),
            end_date: moment(_this.visitDetail.finished_at).format(
              "YYYY-MM-DD"
            ),
            end_time: moment(_this.visitDetail.finished_at).format("HH:mm"),
            force: 0,
            all: 1,
          },
        })
        .then(({ data }) => {
          _this.engineerList = data.engineers;
          // _this.engineerDialog = true;
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.loadingEngineers = false;
        });
    },
    downloadPDF() {
      if (this.closer.pdf_url) {
        window.open(this.closer.pdf_url, "_blank");
      } else {
        const token = JwtService.getToken();
        const url = `${this.$apiURL}visit/${this.visitDetail.id}/closer/${this.closer.id}/download?token=${token}`;
        window.open(url, "_blank");
      }
    },
    routeToInvoice() {
      const { ticket } = this.visitDetail;

      this.$router.push(
        this.getDefaultRoute("invoice.create", {
          query: {
            customer: this.customer.id,
            property: this.property.id,
            billing: this.billing.id,
            visit: this.visitDetail.id,
            ticket: ticket.id,
          },
        })
      );
    },
    routeDetail() {
      this.$router.push(
        this.getDefaultRoute("visit.detail", {
          params: {
            id: this.visitDetail.id ?? undefined,
          },
        })
      );
    },
    closerServiceFormDialog() {
      const _this = this;
      _this.updateServiceFormDialog = false;
      _this.getActiveTimer();
      _this.loadContent();
    },
    assignServiceForm() {
      const _this = this;

      if (!_this.$refs.assignServiceForm.validate()) {
        return false;
      }

      _this.assignFormLoading = true;

      _this.$store
        .dispatch(POST, {
          url: `job/${_this.detail.id}/visit/${_this.visit}/service-form/${_this.timerServiceForm}`,
          data: {
            timesheet: _this.runningTimer.id || null,
          },
        })
        .then(() => {
          _this.timerServiceForm = new Array();
          ServiceFormEventBus.$emit("reload:service-form");
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.assignFormLoading = false;
          _this.assignServiceFormDialog = false;
          _this.getActiveTimer();
        });
    },
    getBarcode(service) {
      let barcodeStr = this.visitDetail.barcode.split("-");
      barcodeStr = barcodeStr[0];
      let perent = this.visitDetail.barcode.replace(barcodeStr, "SRV");
      return perent + "-" + service.service_barcode;
    },
    assignServiceFormDetail() {
      const _this = this;
      _this.timerLoading = true;

      _this.$store
        .dispatch(QUERY, {
          url: "job/service-forms",
          data: {
            timesheet: _this.runningTimer.id,
            customer: _this.customer.customer,
          },
        })
        .then(({ data }) => {
          _this.serviceFormList = data;
          _this.assignServiceFormDialog = true;
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.timerLoading = false;
        });
    },
    createdTimeCloser() {
      this.closerDialog = false;
      this.$emit("close", true);
      this.$emit("reload", true);
      this.getActiveTimer();
      this.loadContent();
    },
    updatedServiceForm() {
      this.updateServiceFormDialog = false;
      this.getActiveTimer();
    },
    timesheetRunningClose() {
      const _this = this;
      _this.formLoading = true;

      _this.$store
        .dispatch(PATCH, { url: "running-time-sheet" })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.formLoading = false;
          _this.getServiceFormList();
        });
    },
    checkRunningTimerStatus() {
      const _this = this;
      _this.timerLoading = true;

      _this.$store
        .dispatch(GET, { url: "running-time-sheet" })
        .then(({ data }) => {
          if (_this.lodash.isEmpty(data) === false) {
            _this.userRunningTimers = data;
            _this.timesheetRunningDialog = true;
          } else {
            _this.getServiceFormList();
          }
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.timerLoading = false;
        });
    },
    getServiceFormList() {
      const _this = this;
      _this.timerLoading = true;
      _this.$store
        .dispatch(QUERY, {
          url: "job/service-forms",
          data: {
            customer: _this.customer.customer,
          },
        })
        .then(({ data }) => {
          _this.serviceFormList = data;
          _this.startTimerDialog = true;
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.timerLoading = false;
          _this.timesheetRunningDialog = false;
        });
    },
    updateAppointmentDate(param) {
      this.updateAppointmentFormData.date = param;
    },
    updateAppointmentStartTime(param) {
      this.updateAppointmentFormData.start_time = param;
    },
    updateAppointmentEndTime(param) {
      this.updateAppointmentFormData.end_time = param;
    },
    updateAppointment() {
      const _this = this;
      _this.apptFormLoading = true;

      _this.$store
        /* .dispatch(PATCH, {
          url:
            "job/" + _this.detail.id + "/visit/" + _this.visit + "/re-schedule",
          data: {
            date: _this.updateAppointmentFormData.date
              ? moment(_this.updateAppointmentFormData.date).format(
                  "YYYY-MM-DD"
                )
              : moment().format("YYYY-MM-DD"),
            start_time: _this.updateAppointmentFormData.start_time
              ? moment(_this.updateAppointmentFormData.start_time, [
                  "h:mm A",
                ]).format("HH:mm")
              : moment().startOf("day").format("HH:mm"),
            end_time: _this.updateAppointmentFormData.end_time
              ? moment(_this.updateAppointmentFormData.end_time, [
                  "h:mm A",
                ]).format("HH:mm")
              : moment().endOf("day").format("HH:mm"),
          },
        }) */
        .dispatch(PATCH, {
          url:
            "job/" + _this.detail.id + "/visit/" + _this.visit + "/re-schedule",
          data: {
            date: _this.updateAppointmentFormData.date
              ? moment(_this.updateAppointmentFormData.date).format(
                  "YYYY-MM-DD"
                )
              : moment().format("YYYY-MM-DD"),
            end_date: _this.updateAppointmentFormData.end_date
              ? moment(_this.updateAppointmentFormData.end_date).format(
                  "YYYY-MM-DD"
                )
              : moment().format("YYYY-MM-DD"),
            start_time: _this.starTimereschdule
              ? moment(_this.starTimereschdule, ["hh:mm a"]).format("HH:mm")
              : moment().startOf("day").format("HH:mm"),
            end_time: _this.endTimereschdule
              ? moment(_this.endTimereschdule, ["hh:mm a"]).format("HH:mm")
              : moment().endOf("day").format("HH:mm"),
          },
        })
        .then(() => {
          _this.appointmentUpdateDialog = false;
          _this.loadContent();
          _this.$emit("reload-calendar", true);
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.apptFormLoading = false;
        });
    },
    startTimer() {
      const _this = this;
      if (!_this.$refs.timerStartForm.validate()) {
        return false;
      }

      _this.timerFormLoading = true;

      _this.$store
        .dispatch(PATCH, {
          url:
            "job/" + _this.detail.id + "/visit/" + _this.visit + "/timer/start",
          data: {
            detail: _this.timer_remarks,
            service_form: _this.timerServiceForm,
          },
        })
        .then(() => {
          _this.$emit("reload", true);
          _this.startTimerDialog = false;
          _this.timerServiceForm = new Array();
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.timerFormLoading = false;
          _this.getActiveTimer();
          _this.loadContent();
        });
    },
    startTimerWithLater() {
      const _this = this;
      if (_this.isTimmerRunning) {
        _this.closerDialog = true;
      } else {
        _this.timerFormLoading = true;
        _this.$store
          .dispatch(PATCH, {
            url:
              "job/" +
              _this.detail.id +
              "/visit/" +
              _this.visit +
              "/timer/start",
          })
          .catch((error) => {
            _this.logError(error);
          })
          .finally(() => {
            _this.$emit("reload", true);
            _this.timerFormLoading = false;
            _this.getActiveTimer(true);
            _this.loadContent();
          });
      }
    },
    setTimerDuration() {
      const _this = this;
      if (_this.lodash.isEmpty(_this.runningTimer) === false) {
        let startDate = _this.lodash.toString(_this.runningTimer.date);
        if (_this.runningTimer.start_at) {
          startDate = _this.lodash.toString(
            startDate + " " + _this.runningTimer.start_at
          );
        }

        if (startDate && moment(startDate, ["YYYY-MM-DD HH:mm:ss"]).isValid()) {
          startDate = moment(startDate, ["YYYY-MM-DD HH:mm:ss"]);

          let duration = moment.duration(moment().diff(startDate));

          let hours = parseInt(duration.asHours());
          let minutes = parseInt(duration.asMinutes()) % 60;
          let seconds = parseInt(duration.asSeconds()) % 60;

          _this.timerDuration = {
            hour: hours > 0 ? _this.lodash.padStart(hours, 2, "0") : "00",
            minute: minutes > 0 ? _this.lodash.padStart(minutes, 2, "0") : "00",
            second: seconds > 0 ? _this.lodash.padStart(seconds, 2, "0") : "00",
          };
        }
      }
    },
    updateTimerDuration() {
      const _this = this;
      clearInterval(_this.durationInterval);
      _this.durationInterval = setInterval(_this.setTimerDuration, 1000);
    },
    recordingStartedUpdate(param) {
      this.recordingStarted = param;
    },
    recordingStoppedUpdate(param) {
      this.recordingStopped = param;
    },
    stopRunningTimer() {
      const _this = this;

      if (_this.recordingStarted === true && _this.recordingStopped === false) {
        ErrorEventBus.$emit(
          "update:error",
          InitializeError("Please stop the audio recorder then try again.")
        );
        return false;
      }

      _this.formLoading = true;

      _this.$store
        .dispatch(PATCH, {
          url:
            "job/" +
            _this.runningTimer.ticket +
            "/visit/" +
            _this.runningTimer.visit +
            "/timer/" +
            _this.runningTimer.id +
            "/end",
          data: { detail: _this.timer_remarks, audio: _this.audioDataURL },
        })
        .then(() => {
          _this.timerDialog = false;
          _this.timer_remarks = null;
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.formLoading = false;
          _this.getActiveTimer();
          _this.loadContent();
        });
    },
    markAsComplete() {
      const _this = this;
      _this.formLoading = true;

      _this.$store
        .dispatch(PATCH, {
          url:
            "job/" +
            _this.detail.id +
            "/visit/" +
            _this.visit +
            "/update-status/1",
        })
        .then(() => {
          _this.loadContent();
          _this.$emit("reload", true);
          _this.completeDialog = false;
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.formLoading = false;
        });
    },
    stopAllTimers() {
      const _this = this;
      _this.formLoading = true;

      _this.$store
        .dispatch(PATCH, {
          url: "visit/" + _this.visit + "/stop-all-timer",
        })
        .then(() => {
          _this.loadContent();
          _this.$emit("reload", true);
          _this.allTimerDialog = false;
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.formLoading = false;
        });
    },
    checkTimerStatus() {
      const _this = this;
      clearInterval(_this.timeInterval);
      _this.timeInterval = setInterval(
        _this.getActiveTimer,
        _this.timeIntervalLimit
      );
    },
    getActiveTimer(closer) {
      const _this = this;
      if (_this.visitDetail.status < 4) {
        _this.timerLoading = true;
        _this.$store
          .dispatch(GET, {
            url: "visit/" + _this.visit + "/running",
          })
          .then(({ data }) => {
            if (data && !isEmpty(data)) {
              _this.runningTimer = new Object(data);
              _this.ticketId = data.ticket;
              _this.visitId = data.visit;
            }

            _this.isTimmerRunning = !!data;

            if (_this.isTimmerRunning) {
              _this.resumeTimerDialog = false;
            }

            if (closer) {
              _this.$nextTick(() => {
                _this.closerDialog = true;
              });
            }
          })
          .catch((error) => {
            _this.logError(error);
          })
          .finally(() => {
            _this.timerLoading = false;
          });
      }
    },
    updateField(type) {
      const _this = this;
      if (_this.canUpdateVisit) {
        if (!_this.allowUpdate) {
          return false;
        }
        _this.onEscParticularField();
        _this.updateDetailDialog[type] = true;
        _this.updateDetail[type] = _this.visitDetail[type];
        setTimeout(function () {
          _this.$refs[type].focus();
        }, 50);
      }
    },
    onEscParticularField() {
      this.updateDetailDialog = {
        title: false,
        instruction: false,
      };
      this.updateDetail = {
        title: null,
        instruction: null,
      };
    },
    patchVisit(data) {
      const _this = this;
      return new Promise((resolve, reject) => {
        try {
          _this.$store
            .dispatch(PATCH, {
              url: "visit/" + _this.visit,
              data,
            })
            .then((response) => {
              resolve(response.data);
            })
            .catch((error) => {
              reject(error);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
    updateParticularField() {
      const _this = this;
      _this.particuleFieldLoading = true;
      if (_this.canUpdateVisit) {
        _this
          .patchVisit(_this.updateDetail)
          .catch((error) => {
            _this.logError(error);
          })
          .finally(() => {
            _this.loadContent();
            _this.particuleFieldLoading = false;
            _this.onEscParticularField();
          });
      }
    },
    resumeTimer() {
      const _this = this;
      _this.timerFormLoading = true;
      _this.$store
        .dispatch(PATCH, { url: "visit/" + _this.visit + "/resume" })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.timerFormLoading = false;
          _this.getActiveTimer();
          _this.loadContent();
        });
    },
    downloadVisit() {
      try {
        let startDateArray = moment(this.visitDetail.started_at)
          .format("YYYY-MM-DD")
          .split("-")
          .map((row) => toNumber(row));

        let startTimeArray = moment(this.visitDetail.started_at)
          .format("HH:mm")
          .split(":")
          .map((row) => toNumber(row));

        let endDateArray = moment(this.visitDetail.finished_at)
          .format("YYYY-MM-DD")
          .split("-")
          .map((row) => toNumber(row));

        let endTimeArray = moment(this.visitDetail.finished_at)
          .format("HH:mm")
          .split(":")
          .map((row) => toNumber(row));

        if (startTimeArray[0] == "00") {
          startTimeArray = new Array();
        }

        const visit = {
          start: this.lodash.concat(startDateArray, startTimeArray),
          end: this.lodash.concat(endDateArray, endTimeArray),
          title: this.visitDetail && this.visitDetail.title,
          description: this.visitDetail.instruction,
          location: this.property.property_address,
          url: process.env.VUE_APP_BASE_URL,
          geo: {
            lat: toNumber(this.property.latitude),
            lon: toNumber(this.property.longitude),
          },
          categories: this.detail.ticket_type,
          status: "CONFIRMED",
          organizer: {
            name: this.detail.added_by.display_name,
            email: this.detail.added_by.user_email,
          },
          attendees: this.visitDetail.engineers.map((row) => {
            if (row.engineer) {
              return {
                name: row.engineer.full_name,
                email: row.engineer.primary_email,
              };
            }
          }),
        };
        downloadEvent(visit);
      } catch (error) {
        ErrorEventBus.$emit("update:error", InitializeError(error));
      }
    },
    getVisitScheduleType() {
      return this.detail ? this.detail.schedule_message : "";
    },
    loadContent() {
      const _this = this;
      _this.pageLoading = true;
      _this.$store
        .dispatch(GET, {
          url: "visit/" + _this.visit,
        })
        .then(({ data }) => {
          _this.visitDetail = data;

          _this.starTimereschdule = moment(_this.visitDetail.started_at).format(
            "hh:mm A"
          );
          _this.endTimereschdule = moment(_this.visitDetail.finished_at).format(
            "hh:mm A"
          );

          _this.closer = data.closer;
          _this.detail = data.ticket;
          _this.customer = data.customer;
          _this.contactPerson = data.contact_person || new Object();
          _this.property = data.property || new Object();
          _this.property_contact_person =
            data.property_contact_person || new Object();
          _this.billing_contact_person =
            data.billing_contact_person || new Object();
          _this.billing = data.billing || new Object();
          _this.visitNotes = data.notes;
          _this.allowUpdate = true;
          if (_this.visitDetail.status === 4) {
            _this.allowUpdate = false;
            clearInterval(_this.timeInterval);
            clearInterval(_this.durationInterval);
          }

          if (
            _this.visitDetail.engineers &&
            _this.visitDetail.engineers.length
          ) {
            _this.assignedTeam = _this.visitDetail.engineers.map(
              (row) => row.engineer
            );
          }
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.getActiveTimer();
          _this.pageLoading = false;
        });
    },
  },
  components: {
    Dialog,
    Barcode,
    Priority,
    Datepicker,
    // Timepicker,
    // VueTimepicker,
    CreateTimeCloser,
    DeleteDialog,
    CustomStatus,
  },
  computed: {
    dialogWidth() {
      return this.lodash.toSafeInteger((document.body.clientWidth / 100) * 70);
    },
    updateStartDate() {
      if (this.lodash.isEmpty(this.visitDetail) === false) {
        return moment(this.visitDetail.started_at).format("YYYY-MM-DD");
      }
      return null;
    },
    updateStartTime() {
      if (this.lodash.isEmpty(this.visitDetail) === false) {
        return moment(this.visitDetail.started_at).format("hh:mm A");
      }
      return null;
    },
    updateEndTime() {
      if (this.lodash.isEmpty(this.visitDetail) === false) {
        return moment(this.visitDetail.finished_at).format("hh:mm A");
      }
      return null;
    },
    canUpdateVisit() {
      if (this.visitDetail && this.visitDetail.status != 1) {
        return false;
      }
      return this.getPermission("visit:update");
    },
    getAppointmentTextold() {
      if (this.lodash.isEmpty(this.visitDetail) === false) {
        let date = this.formatDate(this.visitDetail.started_at);
        let startTime = moment(this.visitDetail.started_at).format("hh:mm A");
        let endTime = moment(this.visitDetail.finished_at).format("hh:mm A");
        return date + " " + startTime + " - " + endTime;
      }
      return null;
    },
    getAppointmentText() {
      if (this.lodash.isEmpty(this.visitDetail) === false) {
        let date = this.formatDate(this.visitDetail.started_at);
        let startTime = moment(this.visitDetail.started_at).format("hh:mm A");
        let enddate = this.formatDate(this.visitDetail.finished_at);
        let endTime = moment(this.visitDetail.finished_at).format("hh:mm A");
        return `${date} ${startTime} - ${enddate} ${endTime}`;
      }
      return null;
    },
    getScheduleType() {
      if (this.detail) {
        if (this.detail.type === 1) {
          return "One-Off Job";
        }
        if (this.detail.type === 2) {
          return "Recurring Job";
        }
      }
      return null;
    },
  },
};
</script>
